"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadableHVACMode = exports.ReadableMode = void 0;
const ComponentType_1 = require("./ComponentType");
const ModeType_1 = require("./ModeType");
const HVAC_1 = require("./HVAC");
exports.ReadableMode = {
    [ModeType_1.ModeType.Away]: 'Away',
    [ModeType_1.ModeType.Cinema]: 'Cinema',
    [ModeType_1.ModeType.OnBoard]: 'On Board',
    [ModeType_1.ModeType.Sleep]: 'Sleep',
};
exports.ReadableHVACMode = {
    [HVAC_1.HVACMode.Cool]: 'Air Conditioner',
    [HVAC_1.HVACMode.Heat]: 'Heat Pump',
    [HVAC_1.HVACMode.FanOnly]: 'Fan Only',
    [HVAC_1.HVACMode.Off]: 'Off',
};
//# sourceMappingURL=ReadableComponents.js.map